export default function Required() {
	return <span className='text-required'>*</span>;
}
